module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module-brand-left"
  }, [_c('ad-list', {
    attrs: {
      "data": _vm.qyLeftUpAdv.advList,
      "adDetail": _vm.qyLeftUpAdv.adDetails
    }
  }), _vm._v(" "), _c('ad-list', {
    attrs: {
      "data": _vm.qyLeftDownAdv.advList,
      "adDetail": _vm.qyLeftDownAdv.adDetails
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b217555a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home-page/brand/left-ad/index.vue
// module id = 1659
// module chunks = 1